import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class DataBlockGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var dataBlockGrid = this;
		setTimeout(function(){
			dataBlockGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var dataBlockGrid = this;		
	
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [											
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompanyId',
					'class': 'spacer-toolbar-item',
					'keep-open': true,										
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						Service.getCompanyService().getCompaniesLookup().then(function(data){
							combo.items = data;
						});
					},
					placeHolder: 'Select',					
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'filterDataType',
					label: 'Data Type',
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'description',
					'prevent-invalid-input': true,					
					value: 'gps',
					postinit: function(combo) {							
						Service.getLookupService().getLookupValues('DataBlockType').then(function (data) {
							var primaryData = [];							
							data.forEach(function(item){
								if (item.primaryDataBlock) {
									primaryData.push(item);
								}
							});
							combo.items = primaryData;
							combo.required = false;
						});
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					label: 'Unit Id',
					name: 'unitId',
					listeners: {
						input: {
							fn: function(e) {
								actionRefresh();
							},
							buffer: 1000
						}
					}						
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Update Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'Update End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endCurrentMonth());	
					}()
				}				
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},				
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_DATA_BLOCK:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					properties: {
						menu: [
							{
								tag: 'dl-action-menu-item',
								itemId: 'editFormat',							
								permissions: ['ADMIN_DATA_BLOCK:WRITE'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:lines-list"></vaadin-icon> Formatted',
								listeners: {
									click: function(event) {
										actionEdit(grid.selectedItems[0], false);
									}
								}
							},
							{
								tag: 'dl-action-menu-item',
								itemId: 'editNoFormat',							
								permissions: ['ADMIN_DATA_BLOCK:WRITE'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:cloud-o"></vaadin-icon> No Format',
								listeners: {
									click: function(event) {
										actionEdit(grid.selectedItems[0], true);
									}
								}
							}
						]
					}				
				},
				{
					tag: 'dl-action-button',
					itemid: 'download',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_DATA_BLOCK:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:download', ' Download')						
					],
					properties: {
						menu: [
							{
								tag: 'dl-action-menu-item',
								itemId: 'downloadDecompress',							
								permissions: ['ADMIN_DATA_BLOCK:READ'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:expand-square"></vaadin-icon> Decompress',
								listeners: {
									click: function(event) {
										actionDownload(grid.selectedItems[0], true);
									}
								}
							},
							{
								tag: 'dl-action-menu-item',
								itemId: 'downloadBinary',							
								permissions: ['ADMIN_DATA_BLOCK:READ'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:compress"></vaadin-icon> Binary',
								listeners: {
									click: function(event) {
										actionDownload(grid.selectedItems[0], false);
									}
								}
							}
						]
					}				
				},				
				{
					tag: 'div',
					style: 'float: right;',
					children:[						
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							'class': 'spacer-toolbar-item',	
							theme: 'error primary',
							disabled: 'delete',
							permissions: ['GPS_MANAGEMENT:DELETE'],							
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')						
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}							
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [			
				{						
					path: 'pkValue',
					header: 'Key',
					width: '7em'
				},
				{						
					path: 'dataBlockPK.referenceType',
					header: 'Reference Type',
					width: '7em'
				},
				{						
					path: 'dataBlockPK.referenceId',
					header: 'Unit Id',
					width: '7em'
				},
				{						
					path: 'dataBlockPK.dataBlockKey',
					header: 'Block Key',
					width: '7em'
				},				
				{						
					path: 'dataSizeBytes',
					header: 'Data Size (bytes)',
					width: '7em',
					'text-align': 'end'
				},
				{						
					path: 'updateDts',
					header: 'Last Update Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						ElementUtil.query(toolbar, 'download').disabled = false; 
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {						
						ElementUtil.query(toolbar, 'edit').disabled = true; 
						ElementUtil.query(toolbar, 'download').disabled = true; 
						ElementUtil.query(toolbar, 'delete').disabled = true;	
					}
					
				}
			}
		});					
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
							
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterEndDate').value);		
						
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',
							start: startFilterDts,														
							end: endFilterDts,
							dateField: 'updateDts',
							filterField: 'dataBlockPK.referenceId',
							filterValue: ElementUtil.query(toolbarFilter, 'filterValue').value
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];							
							
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();
						
						};
						
						var companyId = ElementUtil.query(toolbarFilter, 'filterCompanyId').value;
						var dataType = ElementUtil.query(toolbarFilter, 'filterDataType').value;
						if (companyId && dataType) {						
							DataManagementService.getDataBlockService().getDataBlocks(companyId, dataType, grid.currentFilter).then(function(records){
								successHandler(records);
							});						
						} else {													
							loadMask.remove();
							if (dataBlockGrid.nextGridLoad) {	
								ElementUtil.query(toolbarFilter, 'filterCompanyId').validate();								
								ElementUtil.query(toolbarFilter, 'filterDataType').validate();	
								DL.MessageUtil.showToastError('A Company and Data Type must be selected');
							} else {
								dataBlockGrid.nextGridLoad = true;
							}
						
						}
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});

		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				actionExport();
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		dataBlockGrid.append(flexLayout);		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};

		var actionExport = function() {
			var companyId = ElementUtil.query(toolbarFilter, 'filterCompanyId').value;
			var dataType = ElementUtil.query(toolbarFilter, 'filterDataType').value;
			if (!companyId || !dataType) {
				ElementUtil.query(toolbarFilter, 'filterCompanyId').validate();
				ElementUtil.query(toolbarFilter, 'filterDataType').validate();
				DL.MessageUtil.showToastError('A Company and Data Type must be selected');
				return;
			}
			var exportFilter = Object.assign({}, grid.currentFilter || {});
			delete exportFilter.offset;
			delete exportFilter.max;
			DataManagementService.getDataBlockService().exportDataBlocks(companyId, dataType, exportFilter);
		};
		
		var actionDelete = function(record){
			
			var dataType = ElementUtil.query(toolbarFilter, 'filterDataType').value;
			if (dataType) {
				window.DL.MessageUtil.showConfirm({
					title: 'Confirm Delete',
					message: '<b>Are you sure you want to delete "' + record.pkValue + '"?</b> <br><i class="fas fa-exclamation-triangle warning-icon"></i>This will remove all data in the block and indexes will need resyncing<br>(this should occur automatically).',
					buttons: [
						{
							text: 'Yes',
							handler: function() {
								var loadMask = grid.showLoading('Removing...');

								DataManagementService.getDataBlockService().deleteDataBlock(record.pkValue, dataType)
								.then(function(){
									loadMask.remove();
									window.DL.MessageUtil.showToast('Success', 'Removed '+ record.pkValue, {									
										theme: 'success'
									});
									actionRefresh();
								});						
							}
						},
						{
							text: 'No'
						}
					]
				});
			} else {
				ElementUtil.query(toolbarFilter, 'filterDataType').validate();
				window.DL.MessageUtil.showToastError('Data type must be selected');
			}
		};
		
		var actionEdit = function(record, noFormat) {
			var dataType = ElementUtil.query(toolbarFilter, 'filterDataType').value;
			if (dataType) {
				var editWin = ElementUtil.create({
					tag: 'dl-dialog',
					title: 'Edit',
					icon: 'vaadin:edit',
					width: .75,
					height: .75,
					listeners: {
						ready: function () {
							editWin.show();

							var formPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'vaadin-form-layout',
										children: [
											{
												tag: 'vaadin-text-field',
												name: 'dataBlockKey',
												label: 'Block Key',
												required: true,
												colspan: 2,
												maxLength: 255
											},
											{
												tag: 'vaadin-text-area',
												name: 'jsonData',
												label: 'JSON Data (need to be valid)',
												colspan: 2,												
												required: true
											},
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:database', 'Save')
														],
														listeners: {
															click: function () {

																formPanel.submitForm({
																	preSubmit: function (data) {
																		return data;
																	},
																	actualCall: function (data) {

																		var saveBlock = {
																			dataBlockPK: record.dataBlockPK,
																			blockDataType: dataType,
																			jsonData: data.jsonData
																		};
																		saveBlock.dataBlockPK.dataBlockKey = data.dataBlockKey;
																		
																		return DataManagementService.getDataBlockService().saveDataBlock(record.pkValue, dataType, saveBlock);
																	},
																	success: function (data, responseData) {
																		window.DL.MessageUtil.showToast('Success', 'Saved ' + record.pkValue, {
																			theme: 'success',
																			position: 'top-stretch'
																		});
																		actionRefresh();
																		editWin.close();
																	}
																});

															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function () {
																//cancel
																editWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
							});

							editWin.addToContentElement(formPanel);
							
							var loadMask = formPanel.showLoading();
							DataManagementService.getDataBlockService().getData(record.pkValue, dataType, noFormat).then(function(data){
								loadMask.remove();
																
								formPanel.load({
									dataBlockKey: record.dataBlockPK.dataBlockKey,
									jsonData: data
								});
								
							});
							
						}
					}
				});
								
			} else {
				ElementUtil.query(toolbarFilter, 'filterDataType').validate();
				window.DL.MessageUtil.showToastError('Data type must be selected');
			}
			
		};
		
		var actionDownload = function(record, decompress) {
			
			var dataType = ElementUtil.query(toolbarFilter, 'filterDataType').value;
			if (dataType) {				
				DataManagementService.getDataBlockService().downloadData(record.pkValue, dataType, decompress);			
			} else {
				ElementUtil.query(toolbarFilter, 'filterDataType').validate();
				window.DL.MessageUtil.showToastError('Data type must be selected');
			}
			
		};
		
	}
	
	
};
customElements.define('dl-datablock-grid', DataBlockGrid);
